export enum ProgramStatus {
  INIT = 'INIT',
  ACTIVE = 'ACTIVE',
  CLOSE = 'CLOSE',
  FINISHED = 'FINISHED',
}

// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace ProgramStatus {
  export function getDisplayText(status: ProgramStatus): string {
    switch (status) {
      case ProgramStatus.INIT:
        return 'טרם התחיל';
      case ProgramStatus.ACTIVE:
        return 'פעיל';
      case ProgramStatus.FINISHED:
        return 'הסתיים';
      case ProgramStatus.CLOSE:
        return 'נסגר';
      default:
        return '';
    }
  }

  export function parseProgramStatus(status: string): ProgramStatus {
    return (
      ProgramStatus[status as keyof typeof ProgramStatus] ?? ProgramStatus.INIT
    ); // Default to INIT if not found
  }
}
